import { uniq } from '@/utils/array.ts';

export const normalizeEmailsList = (emails: string[]) =>
  uniq(emails).sort((leftValue, rightValue) => leftValue.localeCompare(rightValue, 'en'));
